// useFormValidation.js
import { useState } from 'react';

import { validateContent, validateDemo, validateStep1Info, validateStep2AddressInfo } from '@src/plugins/validationUtils'; // Import the pure function

// A custom hook that manages validation state and returns handlers
export const useFormValidation = (formData, onNext, currentStep) => {
  // 1. State for validation errors
  const [errors, setErrors] = useState({});

  // 2. Validation Logic and state update
  const validateAndSetErrors = () => {
    // Use the imported pure function
    // console.log(formData);
    const newErrors = {...validateStep1Info(formData, currentStep), ...validateStep2AddressInfo(formData, currentStep)};

    setErrors(newErrors);
    // console.log(newErrors)
    // Return true if valid
    return Object.keys(newErrors).length === 0;
  };

  // 3. Updated onSubmit Handler
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateAndSetErrors()) {
      onNext(); // Call the component's onNext prop
      setErrors({});
    }
  };

  // Function to clear a specific error when input changes
  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      setErrors((prev) => ({...prev, [fieldName]: undefined}));
    }
  };

  // Return the state and functions needed by the form component
  return {
    errors,
    setErrors,
    handleSubmit,
    clearError,
    validateAndSetErrors, // useful if you need to manually trigger validation
  };
};

export const useContentFormValidation = (formData, onNext, setErrors, currentStep) => {
  // NO internal state (useState) for errors

  // 2. Validation Logic and error update
  const validateAndSetErrors = () => {
    const newErrors = {...validateContent(formData, currentStep)};

    setErrors(newErrors); // Use the passed-in setter/dispatch function

    // Return true if valid
    return Object.keys(newErrors).length === 0;
  };

  // 3. Updated onSubmit Handler
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateAndSetErrors()) {
      onNext(); // Call the component's onNext prop
      setErrors({}); // Clear errors upon successful validation
    }
  };

  // Return the handlers needed by the form component
  return {
    handleSubmit,
    validateAndSetErrors,
  };
};

export const useDemoFormValidation = (formData, onNext, setErrors, currentStep) => {
  // 2. Validation Logic and error update
  const validateAndSetErrors = () => {
    const newErrors = {...validateDemo(formData, currentStep)};

    setErrors(newErrors); // Use the passed-in setter/dispatch function

    // Return true if valid
    return Object.keys(newErrors).length === 0;
  };

  // 3. Updated onSubmit Handler
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateAndSetErrors()) {
      onNext(); // Call the component's onNext prop
      setErrors({}); // Clear errors upon successful validation
    }
  };


  // Return the state and functions needed by the form component
  return {
    handleSubmit,
    validateAndSetErrors,
  };
};
